import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreviewSection() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-secondary-600">
            <i className="ri-question-answer-line" aria-hidden="true"></i>
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者最常追问的几件事
          </h2>
          <p className="mt-4 text-sm leading-loose text-foreground-700">
            关于内定传言、评分猫腻的证据尺度，以及我们如何判断一条爆料是否可信，这里给出了完整的回答。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-foreground-900 px-5 py-2.5 font-label text-sm text-foreground-900 transition-colors hover:bg-foreground-900 hover:text-background-50 whitespace-nowrap"
          >
            查看全部问答
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 4)} defaultOpenId="f1" />
        </div>
      </div>
    </section>
  );
}